import { render, staticRenderFns } from "./OrderControllerFormPreview.vue?vue&type=template&id=0c06258c&"
import script from "./OrderControllerFormPreview.vue?vue&type=script&lang=js&"
export * from "./OrderControllerFormPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports